import { createFileRoute } from '@tanstack/react-router';

import { PolicyEditPage, policyQueryOptions } from '@/features/policies';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/policies/$policyId')({
  staticData: { tours: ['settings.policy-editor'] },
  loader: async ({ context, params }) => {
    const policy = await context.queryClient.query({
      ...policyQueryOptions(params.storeId, params.policyId),
      staleTime: 'static',
    });
    return { crumb: policy.title };
  },
  component: PolicyEditPage,
});
